import type { AuthPhase } from '../context/AuthContext';
import { ROUTES } from './routes';

export function pathForPhase(phase: AuthPhase): string {
  switch (phase) {
    case 'unauthenticated':
      return ROUTES.PUBLIC_LOGIN;
    case 'terms_acceptance':
      return ROUTES.GATED_TERMS_ACCEPTANCE;
    case 'onboarding':
      return ROUTES.GATED_ONBOARDING;
    case 'subscription':
      return ROUTES.GATED_PLAN_SELECTION;
    case 'billing_recovery':
      return ROUTES.GATED_BILLING_RECOVERY;
    case 'intake':
      return ROUTES.GATED_POST_PAYMENT_ONBOARDING;
    case 'b2b_plan_selection':
      return ROUTES.GATED_B2B_PLAN_SELECTION;
    case 'school_inactive':
      return ROUTES.GATED_SCHOOL_INACTIVE;
    case 'authenticated':
      return ROUTES.TABS_ROOT;
    default:
      return ROUTES.PUBLIC_LOGIN;
  }
}

// Helper to determine if a phase requires the public layout
export function isPublicPhase(phase: AuthPhase): boolean {
  return [
    'unauthenticated',
  ].includes(phase);
}
